/**
 * Editable starting instruction for Outpaint. The worker keeps its mode-specific
 * composition rules around this text so guided layouts remain deterministic.
 */
export const OUTPAINT_DEFAULT_USER_INSTRUCTION =
  'Extend the image naturally without introducing a new main subject or changing the source.'

/**
 * Editable starting instruction for AI Upscale. It is shared with the client so
 * users can see, adjust, and save the exact instruction sent to Gemini.
 */
export const UPSCALE_PRESERVE_PROMPT = [
  'Create a higher-resolution version of the supplied image while preserving it as faithfully as possible.',
  'Keep the exact composition, framing, camera angle, perspective, subjects, objects, poses, proportions, colors, lighting, shadows, and visual style.',
  'Preserve facial identity, expression, clothing, accessories, text, logos, architecture, and background elements as accurately as possible.',
  'Do not add or remove elements. Do not crop, reframe, redesign, reinterpret, or change the artistic style.',
  'Only reconstruct detail where necessary for the higher-resolution output. The result must look like the same image rendered at a higher native resolution.'
].join('\n')
